export const RegExp = /[А-Яа-яA-Za-z]+$/;